module.exports = __webpack_public_path__ + "img/unsign.75efdace.svg";